// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single_fact_check_report_donation_container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 40px;
}
.single_fact_check_report_donation_wrapper {
  height: 100%;
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.related_recent_fact_check_container {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}
.related_recent_fact_check_wrapper {
  height: 100%;
  width: 90%;
  display: flex;
  flex-direction: column;
}
.related_recent_fact_check_title_container {
  height: 80px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.related_fact_check_title_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 15px;
}
.recent_fact_check_title_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 15px;
}
.related_recent_fact_check_card_container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.related_fact_check_container {
  height: 100%;
  display: grid;
  grid-template-columns: 50% 50%;
  row-gap: 30px;
  column-gap: 30px;
}
.recent_fact_check_container {
  height: 100% !important;
  width: 100% !important;
  row-gap: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.related_fact_check_banner {
  width: 55%;
  display: flex;
  flex-direction: column;
}
.recent_fact_check_banner {
  width: 35%;
  display: flex;
  flex-direction: column;
}
.recent_fact_check_card_container {
  height: 20%;
  width: 100%;
  display: flex;
  flex-direction: row;
  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
  cursor: pointer;
}
.recent_fact_check_thumbnail {
  width: 100%;
  object-fit: contain;
  height: 100%;
}
.recent_fact_check_thumbnail_container {
  width: 35%;
  object-fit: cover;
}
.recent_fact_check_inner_title_container {
  height: 100%;
  width: 65%;
  overflow: hidden;
  padding: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.recent_fact_check_title_wrapper {
  width: 100%;
  overflow: hidden !important;
}

.single_fact_check_claim_content_container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.single_fact_check_claim_content_wrapper {
  width: 90%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  gap: 40px;
}
.single_fact_check_claim_container {
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
  
}
.single_fact_check_content_container {
  height: 100%;
  width: 100%;
}
.single_fact_claim_title {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.youTurn_rating_image {
  width: 50%;
  margin-top: 3%;
  margin-bottom: 10%;
}
.single_fact_check_rating_container {
  display: flex;
  justify-content: center !important;
  align-items: center;
  width: 100%;
}
.single_fact_check_whats_app_container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.single_fact_details_title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 40px;
}
.recent_fact_check_title_text {
  font-size: "Kufam" !important;
  font-weight: 600;
}
.report_modal {
  max-width: 600px;
  margin: auto;
  border-radius: 8px !important;
}

.report_modal_close_icon {
  font-size: 20px;
  color: white;
}

.report_modal_content {
  padding: 15px 15px 25px 15px;
}

.report_modal_footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.report_modal_submit_button {
  background-color: rgb(220, 53, 69);
  border-color: rgb(220, 53, 69);
  cursor: pointer;
  border: none;
}

.report_modal_submit_button:hover {
  background-color: rgb(220, 53, 69) !important;
  color: white !important ;
  border: none !important;
}
.single_fact_check_report_container {
  width: 58%;
}

.whatsapp_channel_container {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #00704a;
}

.whatsapp_channel_text {
  font-family: "Kufam";
  color: white;
}

.whatsapp_channel_icon {
  width: 75% !important;
  margin-right: 10px;
}

.fact_check_share_save_container {
  padding: 4% 0 4% 0;
}
.related_fact_check_title_container > h4 {
  font-family: "Kufam";
  font-weight: 800;
}
.single_fact_check_spread_news_container {
  margin-bottom: 20px;
}

.recent_fact_check_card_skeleton {
  height: 100% !important;
  width: 100% !important;
}
.single_fact_check_rating_skeleton {
  width: 100% !important;
  height: 100% !important;
}

.recent_fact_check_title_container > h4 {
  font-size: "Kufam" !important;
  font-weight: 600;
}
.single_fact_claim_title > h5 {
  font-weight: 800;
  font-family: "Kufam";
}
.single_fact_details_title > h5 {
  font-family: "Kufam";
  font-weight: 800;
}
.whatsapp_channel_text_en {
  font-family: "Kufam";
  color: white;
}
.recent_fact_check_title_text_ta {
  font-size: "Kufam" !important;
  font-weight: 600;
}
.report_modal.ant-modal .ant-modal-content {
  padding: 0px;
}
.report_modal_title {
  color: white;
  font-size: 20px;
  font-weight: bold;
}
.report_modal_title_container {
  background-color: var(--background-theme-color);
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px 8px 0px 0px;
}
.report_cancel_button {
  background-color: #30719c;
  border-color: #30719c;
  color: white;
  border: none !important;
}

.report_cancel_button:hover {
  background-color: #30719c !important;
  color: white !important;
  border: none !important;
}
.report_title_container{
  margin-bottom: 20px;
  text-align: center;
}

.iframe-loading {
  position: relative;
}

.loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 50px;
  border: 5px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #3498db;
  animation: spin 1s linear infinite;
}



@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/layout/user_single_fact_check.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oDAAoD;EACpD,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;;AAExB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,+CAA+C;EAC/C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;AACpC;;;;AAIA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".single_fact_check_report_donation_container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 30px;\n  margin-bottom: 40px;\n}\n.single_fact_check_report_donation_wrapper {\n  height: 100%;\n  width: 90%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.related_recent_fact_check_container {\n  width: 100%;\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 30px;\n}\n.related_recent_fact_check_wrapper {\n  height: 100%;\n  width: 90%;\n  display: flex;\n  flex-direction: column;\n}\n.related_recent_fact_check_title_container {\n  height: 80px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.related_fact_check_title_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 15px;\n}\n.recent_fact_check_title_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 15px;\n}\n.related_recent_fact_check_card_container {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.related_fact_check_container {\n  height: 100%;\n  display: grid;\n  grid-template-columns: 50% 50%;\n  row-gap: 30px;\n  column-gap: 30px;\n}\n.recent_fact_check_container {\n  height: 100% !important;\n  width: 100% !important;\n  row-gap: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.related_fact_check_banner {\n  width: 55%;\n  display: flex;\n  flex-direction: column;\n}\n.recent_fact_check_banner {\n  width: 35%;\n  display: flex;\n  flex-direction: column;\n}\n.recent_fact_check_card_container {\n  height: 20%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n  cursor: pointer;\n}\n.recent_fact_check_thumbnail {\n  width: 100%;\n  object-fit: contain;\n  height: 100%;\n}\n.recent_fact_check_thumbnail_container {\n  width: 35%;\n  object-fit: cover;\n}\n.recent_fact_check_inner_title_container {\n  height: 100%;\n  width: 65%;\n  overflow: hidden;\n  padding: 4px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.recent_fact_check_title_wrapper {\n  width: 100%;\n  overflow: hidden !important;\n}\n\n.single_fact_check_claim_content_container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 15px;\n}\n.single_fact_check_claim_content_wrapper {\n  width: 90%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: 40px;\n}\n.single_fact_check_claim_container {\n  height: 100%;\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  \n}\n.single_fact_check_content_container {\n  height: 100%;\n  width: 100%;\n}\n.single_fact_claim_title {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.youTurn_rating_image {\n  width: 50%;\n  margin-top: 3%;\n  margin-bottom: 10%;\n}\n.single_fact_check_rating_container {\n  display: flex;\n  justify-content: center !important;\n  align-items: center;\n  width: 100%;\n}\n.single_fact_check_whats_app_container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.single_fact_details_title {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 40px;\n}\n.recent_fact_check_title_text {\n  font-size: \"Kufam\" !important;\n  font-weight: 600;\n}\n.report_modal {\n  max-width: 600px;\n  margin: auto;\n  border-radius: 8px !important;\n}\n\n.report_modal_close_icon {\n  font-size: 20px;\n  color: white;\n}\n\n.report_modal_content {\n  padding: 15px 15px 25px 15px;\n}\n\n.report_modal_footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.report_modal_submit_button {\n  background-color: rgb(220, 53, 69);\n  border-color: rgb(220, 53, 69);\n  cursor: pointer;\n  border: none;\n}\n\n.report_modal_submit_button:hover {\n  background-color: rgb(220, 53, 69) !important;\n  color: white !important ;\n  border: none !important;\n}\n.single_fact_check_report_container {\n  width: 58%;\n}\n\n.whatsapp_channel_container {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  background-color: #00704a;\n}\n\n.whatsapp_channel_text {\n  font-family: \"Kufam\";\n  color: white;\n}\n\n.whatsapp_channel_icon {\n  width: 75% !important;\n  margin-right: 10px;\n}\n\n.fact_check_share_save_container {\n  padding: 4% 0 4% 0;\n}\n.related_fact_check_title_container > h4 {\n  font-family: \"Kufam\";\n  font-weight: 800;\n}\n.single_fact_check_spread_news_container {\n  margin-bottom: 20px;\n}\n\n.recent_fact_check_card_skeleton {\n  height: 100% !important;\n  width: 100% !important;\n}\n.single_fact_check_rating_skeleton {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.recent_fact_check_title_container > h4 {\n  font-size: \"Kufam\" !important;\n  font-weight: 600;\n}\n.single_fact_claim_title > h5 {\n  font-weight: 800;\n  font-family: \"Kufam\";\n}\n.single_fact_details_title > h5 {\n  font-family: \"Kufam\";\n  font-weight: 800;\n}\n.whatsapp_channel_text_en {\n  font-family: \"Kufam\";\n  color: white;\n}\n.recent_fact_check_title_text_ta {\n  font-size: \"Kufam\" !important;\n  font-weight: 600;\n}\n.report_modal.ant-modal .ant-modal-content {\n  padding: 0px;\n}\n.report_modal_title {\n  color: white;\n  font-size: 20px;\n  font-weight: bold;\n}\n.report_modal_title_container {\n  background-color: var(--background-theme-color);\n  width: 100%;\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px 8px 0px 0px;\n}\n.report_cancel_button {\n  background-color: #30719c;\n  border-color: #30719c;\n  color: white;\n  border: none !important;\n}\n\n.report_cancel_button:hover {\n  background-color: #30719c !important;\n  color: white !important;\n  border: none !important;\n}\n.report_title_container{\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.iframe-loading {\n  position: relative;\n}\n\n.loading-spinner {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 50px;\n  height: 50px;\n  border: 5px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top-color: #3498db;\n  animation: spin 1s linear infinite;\n}\n\n\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
